import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PrediggoItemsInfoResponse } from '@app/core/prediggo/model/prediggo-items-info-response.model';
import { RecipeService } from '../services/recipe.service';

@Injectable({
  providedIn: 'root'
})
export class RecipeResolver {

  private readonly recipeService = inject(RecipeService);

  public resolve(route: ActivatedRouteSnapshot): Observable<PrediggoItemsInfoResponse> {
    const id = route.paramMap.get('id') as string;
    return this.recipeService.fetchRecipe(id);
  }
}
